import React from 'react';

export const TechStack: React.FC = () => {
  return (
    <section id="tech">
      <div className="container">
        <span className="section-eyebrow">No hardware required</span>
        <h2 className="section-title">It's an app, not a radio.</h2>
        <p className="section-subtitle">
          RoadStatic isn't CB. There's no antenna, no FCC license, no range
          limit on who you can reach. It runs on the phone or tablet you
          already own.
        </p>

        <div className="tech-grid">
          <div className="tech-block">
            <h3>On your device</h3>
            <ul>
              <li>Works on any modern phone, tablet, or laptop browser</li>
              <li>Install it to your home screen — opens like a native app</li>
              <li>One big button. No menus to fumble with at highway speed</li>
              <li>Dark, glare-free screen tuned for night driving</li>
            </ul>
          </div>

          <div className="tech-block">
            <h3>Out on the road</h3>
            <ul>
              <li>Range is wherever you have cell signal — not 5 watts of CB</li>
              <li>Voice goes only to the channel you choose, not the whole band</li>
              <li>Private accounts — no callsigns, no eavesdroppers</li>
              <li>Works the same coast to coast, on any carrier</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};
